import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledEdit = styled.svg<IconProps>`
  & .cls-1 {
    fill: var(--du-color-grey, #969696);
  }

  & .cls-2 {
    stroke: var(--du-color-grey, #969696);
    stroke-width: 1.5;
    fill: none;
  }

  &.hover:hover,
  &.active {
    &:not([disabled]) {
      .cls-1 {
        fill: var(--du-color-primary, #128370);
        stroke-width: 2.5;
      }

      .cls-2 {
        fill: var(--du-color-primary, #128370);
        stroke: var(--du-color-primary, #128370);
        stroke-width: 2;
      }
    }
  }
`;

const FirstPageIcon: React.FC<IconProps> = ({ active, disabled }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledEdit
      id='Edit-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
      disabled={disabled}
    >
      <rect id='Rectangle_4918' data-name='Rectangle 4918' width='32' height='32' fill='#fff' />
      <g id='Group_16026' data-name='Group 16026' transform='translate(-1699.63 -250.5)'>
        <path
          id='Path_15863'
          data-name='Path 15863'
          d='M24.259,27.475,16.527,19.74,24.26,12,23,10.739l-9,9,9,9Z'
          transform='translate(1698 246.761)'
          className='cls-1'
        />
        <line id='Line_435' data-name='Line 435' y2='18' transform='translate(1711.53 257.5)' className='cls-2' />
      </g>
    </StyledEdit>
  );
};

export default FirstPageIcon;
